


















import Vue from "vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";

async function registerServiceWorker() { 
    if ('serviceWorker' in navigator) { 
        try {
            await navigator.serviceWorker.register('/service-worker.js'); 
        } catch (e) {
            window.console.log('Error registering ServiceWorker', e);
            alert('ServiceWorker registration failed. Sorry about that.'); 
        }
    } else {
        const el: HTMLElement|null = document.getElementById('no-offline-support');
        el!.classList.remove('hidden-pwa');
    }
}

export default Vue.extend({
    components: {
        Header,
        Footer,
    },

    data() {
        return {
            fixHeader: false,
        };
    },

    computed: {
        userFeedback(): string { return this.$store.state.userFeedback; },
    },

    created() {
        window.addEventListener('load', registerServiceWorker);
    },

    mounted() {
        // When scrolling, update the fixHeader value to indicate if the header should be fixed or not
        window.addEventListener("scroll", () => {
            this.fixHeader = document.documentElement.scrollTop > 50;
        });

        // Check if we're already logged in
        this.$store.dispatch('logIn', {});
    },

    methods: {
        toggleComicMode() {
            this.$store.commit('toggleComicMode');
        },
    },
});
